import React, { useEffect, useState } from 'react';
import HtmlDiff from 'htmldiff-js';
import ReactHtmlParser from 'react-html-parser';
import { isEmpty } from 'lodash';
import { StatusTag, EmptyState, Spinner } from '@gsa/afp-component-library';
import Truncate from '../../../../components/Truncate';
import StandardItemTitle from '../../components/standard-item-title';
import { useFederalStandards } from '../../fvs-provider';
import { useFvsRequirements } from '../requirements-provider';
import '../styles/requirements.scss';

// eslint-disable-next-line react/prop-types
const RequirementInfo = () => {
  const { standardItem, isSILoading, selectedOptions, standardItems } =
    useFederalStandards();
  const { doHighlightChanges } = useFvsRequirements();

  const [showDiff, setShowDiff] = useState(false);
  const [isNewSI, setIsNewSI] = useState(false);

  useEffect(() => {
    setIsNewSI(false);
    if (
      doHighlightChanges &&
      standardItem?.change?.prevVersionDesc &&
      standardItem?.content?.content
    ) {
      setShowDiff(true);
    } else {
      setShowDiff(false);
    }

    if (standardItem && standardItem?.change?.isInserted === 'Yes') {
      setIsNewSI(true);
    }
  }, [standardItem, doHighlightChanges]);

  // Show spinner while standard items are loading OR while waiting for
  // standardItem to resolve (URL params set but standardItems not yet fetched)
  const isStillResolving =
    selectedOptions?.standardItemNumber &&
    !standardItem &&
    standardItems?.length === 0;

  if (isSILoading || isStillResolving) {
    return <Spinner className="margin-y-9" />;
  }
  
  return (
    <>
      {standardItem && !isEmpty(standardItem?.standardItemNumber) && (
        <>
          {showDiff && (
            <h1>
              <StandardItemTitle
                value={`${standardItem?.standardItemNumber} - ${standardItem?.title}`}
                entity={standardItem}
              />
            </h1>
          )}
          {!showDiff && (
            <h1>
              <StandardItemTitle
                value={`${standardItem?.standardItemNumber} - ${standardItem?.title}`}
                entity={null}
              />
            </h1>
          )}

          {isNewSI && (
            <StatusTag status="active" className="font-body-sm">
              New
            </StatusTag>
          )}

          {standardItem?.content?.content &&
            showDiff &&
            ReactHtmlParser(`<div>
            ${HtmlDiff.execute(
              standardItem?.change?.prevVersionDesc,
              standardItem?.content?.content,
            )}
            </div>`)}

          {standardItem?.content?.content && !showDiff && (
            <Truncate content={standardItem?.content?.content} size={500} />
          )}

          {!standardItem?.content?.content && (
            <div className="text-bold">
              <br />
              &ndash;
            </div>
          )}
          <div className="padding-y-5 width-tablet-lg">
            {/* TODO - change to USWDS  */}
            <div
              style={{ color: '#005EA2', fontWeight: 900 }}
              className="text-bold margin-bottom-2"
            >
              GSA WANTS YOUR FEEDBACK
            </div>

            <div style={{ border: '1px solid #73B3E7' }} className="">
              <ul>
                <li>
                  Comment on Equipment Codes using the{' '}
                  <span className="text-bold">Requirements tab</span>
                </li>
                <li>
                  Comment on this Standard Item using the{' '}
                  <span className="text-bold">Standard Item comments tab</span>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {isEmpty(standardItem?.standardItemNumber) && (
        <EmptyState
          hasBackground
          containerStyles="padding-y-8 margin-top-1 height-full"
          topText={
            <>
              <strong>No Standard items found for the selected criteria</strong>
            </>
          }
          topTextStyles="margin-top-7"
        />
      )}
    </>
  );
};

export default RequirementInfo;
